// extracted by mini-css-extract-plugin
export default {"appIcon":"wJsn9v23","appEntry":"_15gX5hhj","appName":"Rktl7eLS"};